/*
 * @Date: 2020-08-28 15:16:30
 * @Author: MX
 * @LastEditTime: 2024-01-08 17:53:06
 * @Description: 常量配置
 */
//接口前缀
export const APICUS = "openplatformweb"
// 请求成功
export const RESPONSE_SUCCESS = 1
//OpenAPI 对外接口
//test
// let testUrl = 'http://test-openapi.jtexpress.com.cn/webopenplatformapi/api'
// if(process.env.VUE_APP_ENV === 'prod'){
//     testUrl = '/webopenplatformapi/api'
// }
// let testUrlNew = 'http://test-openapi.jtexpress.com.cn'
// if(process.env.VUE_APP_ENV === 'prod'){
//   testUrlNew = ''
// }
export const OPEN_API_TEST = 'https://demoopenapi.jtexpress.co.th/webopenplatformapi/api';
export const OPEN_API_TEST_NEW = 'https://demoopenapi.jtexpress.co.th';
//pro
export const OPEN_API_PRO = `${process.env.VUE_APP_API_URL}/webopenplatformapi/api`

export const policyEffectiveTime = '2023-10-23'

